import Vue from "vue";
import * as MutationsType from "./mutationsType";

export default {
  [MutationsType.SET_CALENDAR](state, payload) {
    state.calendar = payload;
  },
  [MutationsType.UPDATE_CALENDAR](state, payload) {
    let index = (state.calendars || []).findIndex((e) => payload.id === e.id);
    if (index >= 0) Vue.set(state.calendars, index, payload);

    if (state.calendar && state.calendar.id === payload.id) {
      state.calendar = payload;
    }
  },
  [MutationsType.SET_CALENDARS](state, payload) {
    state.calendars = payload;
  },
  [MutationsType.SET_CALENDAR_SELECTED](state, payload) {
    state.calendarSelected = payload;
  },
};
